"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSummaryStore = void 0;
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var Calculator_1 = require("@CommonFrontendBackend/Quote/Calculator");
var Helpers_1 = require("@CommonFrontendBackend/Quote/Helpers");
var Types_1 = require("@CommonFrontendBackend/Quote/Types");
var pages_common_1 = require("@qwilr/pages-common");
var mobx_1 = require("mobx");
var QuoteSummaryStore = (function () {
    function QuoteSummaryStore(quoteSummary, accountQuoteSettings, usingFeature) {
        var _this = this;
        this.accountQuoteSettings = accountQuoteSettings;
        this._quoteSummary = quoteSummary;
        if (usingFeature(FeatureFlag_1.default.QuoteWidgetisation)) {
            (0, mobx_1.reaction)(function () { var _a; return (_a = _this.priceSummary.total["one-off"]) === null || _a === void 0 ? void 0 : _a.billable; }, function (totalBillable) {
                pages_common_1.PubSub.publish("qwilr:quote-total-changed", { total: totalBillable !== null && totalBillable !== void 0 ? totalBillable : 0 });
            });
        }
    }
    Object.defineProperty(QuoteSummaryStore.prototype, "quoteSummary", {
        get: function () {
            return this._quoteSummary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteSummaryStore.prototype, "priceSummary", {
        get: function () {
            return (0, Calculator_1.calculatePriceSummary)(this.quoteSummary, {
                currency: "AUD",
                taxes: this.accountQuoteSettings.taxes.map(function (tax) { return ({
                    id: tax.id,
                    name: tax.name,
                    rate: tax.percent,
                }); }),
                discounts: this.accountQuoteSettings.discounts.map(function (discount) { return ({
                    id: discount.id,
                    name: discount.name,
                    amount: discount.amount,
                    amountType: { percent: "percentage", fixed: "flat" }[discount.type],
                }); }),
            });
        },
        enumerable: false,
        configurable: true
    });
    QuoteSummaryStore.prototype.toggleLineItemSelected = function (id) {
        var itemQuoteSummary = (0, Helpers_1.getQuoteSummaryForItem)(this.quoteSummary, "lineItem", id);
        if (itemQuoteSummary.selection.mode === "optional") {
            itemQuoteSummary.selection.selected = !itemQuoteSummary.selection.selected;
        }
    };
    var _a, _b, _c;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof Types_1.QuoteSummary !== "undefined" && Types_1.QuoteSummary) === "function" ? _a : Object)
    ], QuoteSummaryStore.prototype, "_quoteSummary", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_b = typeof Types_1.QuoteSummary !== "undefined" && Types_1.QuoteSummary) === "function" ? _b : Object),
        __metadata("design:paramtypes", [])
    ], QuoteSummaryStore.prototype, "quoteSummary", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof Types_1.PriceSummary !== "undefined" && Types_1.PriceSummary) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], QuoteSummaryStore.prototype, "priceSummary", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], QuoteSummaryStore.prototype, "toggleLineItemSelected", null);
    return QuoteSummaryStore;
}());
exports.QuoteSummaryStore = QuoteSummaryStore;
